import {RouteBase} from './BaseUrl.jsx'
import {DefaultLayoutConfig} from '../../_metronic/layout/core/DefaultLayoutConfig'
export const userService = {
  login,
  logout,
  Exit,
}

async function PostLogin(url, form) {
  const data = JSON.stringify({
    ...form,
  })

  // le viamos el formulario con fetch por el método post
  const response = await fetch(`${RouteBase}/${url}`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Access-Control-Allow-Origin': '*',
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: data,
  })

  return await response
}

async function login(data) {
  const verificar = localStorage.getItem('metronic-react-demo100')

  var user = await PostLogin('Login/login', data)

  user = await handleResponse(user)
  if (user) {
    // store user details and basic auth credentials in local storage
    // to keep user logged in between page refreshes
    user.authdata = window.btoa(data)
    if (!verificar) {
      localStorage.setItem('metronic-react-demo100', JSON.stringify(DefaultLayoutConfig))
    }
    localStorage.setItem('authUser', JSON.stringify(user))
  }

  return user
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('authUser')
  localStorage.removeItem('img')
}

function Exit() {
  // remove user from local storage to log user out
  localStorage.removeItem('authUser')
  window.location.href = '/login'
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout()
        // eslint-disable-next-line no-restricted-globals
        location.reload(true)
      }
      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }
    return data
  })
}
